module.exports = __webpack_public_path__ + "img/8.3d4afbd4.png";